/**
 * 技能缺口接口（扩展① Gap Radar）。
 * 契约：
 *   GET  /teams/:id/gap                      → GapDto（成员或 admin）
 *   GET  /events/:code/requirements          → RequirementSetDto（登录可见）
 *   PUT  /events/:code/requirements          → RequirementSetDto（organizer/admin；覆盖式）
 *   POST /events/:code/requirements/extract  → {skills, unmatched, via}（organizer/admin；不落库）
 */
import { api } from './client.js';
import type { EventRequirementExtractDto, GapDto, RequirementSetDto } from './types.js';

export const gapApi = {
  get: (teamId: string): Promise<GapDto> => api.get<GapDto>(`/teams/${encodeURIComponent(teamId)}/gap`),

  getRequirements: (eventCode: string): Promise<RequirementSetDto> =>
    api.get<RequirementSetDto>(`/events/${encodeURIComponent(eventCode)}/requirements`),

  setRequirements: (eventCode: string, skills: string): Promise<RequirementSetDto> =>
    api.put<RequirementSetDto>(`/events/${encodeURIComponent(eventCode)}/requirements`, { skills }),

  extractRequirements: (eventCode: string, notice: string): Promise<EventRequirementExtractDto> =>
    api.post<EventRequirementExtractDto>(`/events/${encodeURIComponent(eventCode)}/requirements/extract`, { notice }),
};
